export var PersonalCodeError;
(function (PersonalCodeError) {
    PersonalCodeError["WRONG_LENGTH"] = "WRONG_LENGTH";
    PersonalCodeError["MANDATORY"] = "MANDATORY";
    PersonalCodeError["VALIDATION"] = "VALIDATION";
    PersonalCodeError["MUST_BE_NUMERIC"] = "MUST_BE_NUMERIC";
    PersonalCodeError["CODE_NOT_IN_BASE"] = "CODE_NOT_IN_BASE";
    PersonalCodeError["WRONG_SYMBOL"] = "WRONG_SYMBOL";
    PersonalCodeError["EMPTY_FIELD"] = "EMPTY_FIELD";
    PersonalCodeError["PERSON_EXISTS"] = "PERSON_EXISTS";
})(PersonalCodeError || (PersonalCodeError = {}));
export var Spinner;
(function (Spinner) {
    Spinner["ADD_MANDATE_MODAL"] = "addMandateModal";
    Spinner["EDIT_MANDATE_MODAL"] = "editMandateModal";
})(Spinner || (Spinner = {}));
